// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 发布类型枚举 枚举类
 * 发布类型枚举
 */
export enum EnumPublishType {
  /** 前端 : 前端 */
  Front = 1,
  /** 后端 : 后端 */
  Backend = 2
}

/**
 * 发布类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumPublishTypeMD {
  private static items = [
    new EnumItemMD('Front', 1, '前端', '前端'),
    new EnumItemMD('Backend', 2, '后端', '后端')
  ];

  static getItem(enumItem: EnumPublishType) {
    return this.items.find(item => item.name === EnumPublishType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
